import { Grid } from '@mui/material';

import { FormCard, RenderFormField } from '@/components';

import { NCICFormFields } from '../data';

export const NCICFormPage = () => {
  return (
    <>
      {NCICFormFields.map(({ title, name, items }, index) => (
        <FormCard key={index} title={title}>
          {items.map(({ grid, ...rest }: any) => (
            <Grid
              key={`${name}-${rest.name}`}
              xs={12}
              sm={6}
              md={3}
              {...grid}
              item
            >
              <RenderFormField {...rest} />
            </Grid>
          ))}
        </FormCard>
      ))}
    </>
  );
};
